import React, { CSSProperties, useEffect, useState } from 'react';
import { TextField } from '@mui/material';

import { JoinDescriptionId } from '@models/feature-descriptor-domain';

import {
  DomainsDescriptionsTree,
  FeatureDomainDescriptionsTreeHeader,
  DescriptionsTree,
  useDomainsDescriptionsTreeItemSelection,
  filterDomainsDescriptionsTree,
  createDomainPredicate,
} from '../../feature-descriptor/domains-descriptions-tree';

const headerWrapperStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
};

export const FeatureDomainsDescriptions: React.FC<{
  descriptionsTree: DescriptionsTree;
  selectedJoinIds: JoinDescriptionId[];
  domainName: string;
}> = props => {
  const [selectedDomains] = useDomainsDescriptionsTreeItemSelection();
  const [domainSearchValue, setDomainSearchValue] = useState(() => '');
  const [numberOfDescriptions, setNumberOfDescriptions] = useState(() => 0);

  const [searchedDomain, setSearchedDomain] = useState(
    () => props.descriptionsTree
  );

  useEffect(() => {
    setNumberOfDescriptions(
      calculateNumberOfDescriptions(props.descriptionsTree)
    );
  }, [props.descriptionsTree]);

  useEffect(() => {
    const selectedDomainFilter = createDomainPredicate(
      selectedDomains,
      props.selectedJoinIds
    );
    const domains = filterDomainsDescriptionsTree(
      props.descriptionsTree,
      description =>
        description.description
          .toLowerCase()
          .includes(domainSearchValue.toLowerCase()) &&
        selectedDomainFilter(description)
    );
    setSearchedDomain(domains);
  }, [
    domainSearchValue,
    selectedDomains,
    props.selectedJoinIds,
    props.descriptionsTree,
  ]);

  return (
    <DomainsDescriptionsTree descriptionsTree={searchedDomain}>
      <FeatureDomainDescriptionsTreeHeader>
        <div style={headerWrapperStyle}>
          <h4 style={{ margin: 0 }}>
            {props.domainName}: ({numberOfDescriptions})
          </h4>

          <TextField
            sx={{ top: '-8px', width: '40%' }}
            size="small"
            label={`Search for ${props.domainName.toLowerCase()}`}
            type="search"
            variant="standard"
            margin="dense"
            value={domainSearchValue}
            onChange={e => setDomainSearchValue(e.target.value)}
          />
        </div>
      </FeatureDomainDescriptionsTreeHeader>
    </DomainsDescriptionsTree>
  );
};

function calculateNumberOfDescriptions(
  descriptionsTree: DescriptionsTree
): number {
  return descriptionsTree.types
    .map(({ columns }) =>
      columns.map(({ descriptions }) => descriptions.length)
    )
    .flat(3)
    .reduce((a, b) => a + b, 0);
}
